export enum enumLocalStorageKeys {
  LAST_SENT_VERIFICATION_CODE_DATE = 'LAST_SENT_VERIFICATION_CODE_DATE',
  LAST_SENT_VERIFICATION_CODE_PHONE = 'LAST_SENT_VERIFICATION_CODE_PHONE',
}
